import {
  Button,
  ButtonGroup,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";

export default function OpenForResubmissionModal(props: {
  disclosure: ReturnType<typeof useDisclosure>;
  isLoading: boolean;
  onConfirm: (reason: string) => void;
}) {
  const { disclosure, isLoading, onConfirm } = props;
  const [reason, setReason] = useState("");

  function handleClose() {
    setReason("");
    disclosure.onClose();
  }

  return (
    <Modal isCentered isOpen={disclosure.isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          What should be fixed?
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
          <FormControl>
            <FormLabel>Reason</FormLabel>
            <Textarea
              placeholder="Enter reason for resubmission..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            <FormHelperText>This will be presented to the RN</FormHelperText>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button colorScheme="gray" onClick={handleClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" isLoading={isLoading} onClick={() => onConfirm(reason)}>
              Open for Resubmission
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
